import React from "react";

function Sign() {
  function handleSubmit(e) {
    e.preventDefault();
    const form = e.target;
    const data = new FormData(form);
    const jsonData = {};
    for (let [key, value] of data) {
      jsonData[key] = value;
    }
    fetch("/sign", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(jsonData),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.isToken) {
          alert("נרשמת בהצלחה! יש להיכנס לדואר נכנס ולאשר את המייל.");
          window.location = "/login";
        } else {
          alert("הרשמתך נכשלה. " + res.err);
        }
      });
  }

  return (
    <div
      className="container d-flex justify-content-center align-items-center"
      style={{ minHeight: "100vh" }}
      dir="rtl"
    >
      <div className="card p-4 shadow" style={{ maxWidth: "500px", width: "100%" }}>
        <h2 className="text-center mb-4">הרשמה לאתר</h2>
        <form id="f" method="POST" onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="rol" className="form-label">משכיר דירה או אורח</label>
            <select name="rol" id="rol" className="form-select">
              <option value="0">משכיר</option>
              <option value="1">אורח</option>
            </select>
          </div>

          <div className="mb-3">
            <label htmlFor="first_name" className="form-label">שם פרטי</label>
            <input type="text" className="form-control" name="first_name" id="first_name" required />
          </div>

          <div className="mb-3">
            <label htmlFor="last_name" className="form-label">שם משפחה</label>
            <input type="text" className="form-control" name="last_name" id="last_name" required />
          </div>

          <div className="mb-3">
            <label htmlFor="email" className="form-label">אימייל</label>
            <input type="email" className="form-control" name="email" id="email" required />
          </div>

          <div className="mb-3">
            <label htmlFor="phone" className="form-label">טלפון</label>
            <input type="text" className="form-control" name="phone" id="phone" required />
          </div>

          <div className="mb-3">
            <label htmlFor="password" className="form-label">סיסמה (מינימום 6 תווים)</label>
            <input type="password" className="form-control" name="password" id="password" minLength="6" maxLength="14" required />
          </div>

          <div className="mb-4">
            <label htmlFor="valid_password" className="form-label">אימות סיסמה</label>
            <input type="password" className="form-control" name="valid_password" id="valid_password" required />
          </div>

          <div className="d-grid">
            <button type="submit" className="btn btn-primary">שליחה</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Sign;
